import { Badge, Flex, Progress, Text } from "@chakra-ui/react";

interface ProgressbarProps {
  label?: string;
  value: number;
  valuePercentage?: string;
  rootProps?: Progress.RootProps;
  labelProps?: Progress.LabelProps;
  trackProps?: Progress.TrackProps;
  rangeProps?: Progress.RangeProps;
}

export const Progressbar = ({
  label,
  value,
  valuePercentage,
  rootProps,
  trackProps,
  rangeProps,
  labelProps,
}: ProgressbarProps) => {
  return (
    <Flex width="full" gapX={1} alignItems="center" alignSelf="flex-start">
      <Progress.Root value={value} {...rootProps} width="full">
        {label && (
          <Progress.Label mb="2" {...labelProps}>
            {label}
          </Progress.Label>
        )}
        <Progress.Track {...trackProps}>
          <Progress.Range {...rangeProps} />
        </Progress.Track>
      </Progress.Root>
      {valuePercentage && (
        <Badge
          color="fg"
          bg="border.emphasized"
          height="fit-content"
          mt={label ? "28px" : ""}
        >
          <Text>{valuePercentage}</Text>
        </Badge>
      )}
    </Flex>
  );
};

export default Progressbar;
